/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-restricted-imports
import {
  DirectoryRecordFragment,
  Query_DirectoryController_GetRecords_AllOf_1_List_Items_Status,
} from 'api/generated/graphql';
import { DirectoryRecordData } from 'api/types/data/directory/directory';
import { lodash } from 'helpers';

export const parseDirectoryRecordData = (
  record: DirectoryRecordFragment
): DirectoryRecordData => ({
  ...record,
  isArchivable: record.isArchivable,
  isArchived:
    record.status ===
    Query_DirectoryController_GetRecords_AllOf_1_List_Items_Status.Archived,
  versionNumber: (record as DirectoryRecordFragment).version?.number,
  fields: lodash.compact(record.fields).map((field) => ({
    ...field,
    isEditable: field.isEditable ?? undefined,
    referenceRecord: field.referenceRecord
      ? parseDirectoryRecordData(field.referenceRecord)
      : null,
    value: field?.value
      ? field.value.__typename === 'String_container'
        ? field.value.String
        : field.value.__typename === 'Boolean_container'
        ? field.value.Boolean
        : field.value.__typename === 'Float_container'
        ? field.value.Float
        : field.value.__typename === 'MultiLanguageTextDto'
        ? field.value
        : null
      : null,
  })),
});
